import { nameOfClass } from '@tencent/workbench-core';

/**
 * @internal
 */
function setCustomMetadata(point, store, customMetadata) {
    var _a;
    if (customMetadata) {
        const { from, name, trigger } = point;
        const key = `${nameOfClass(from)}.${trigger}`;
        const custom = (_a = store.get(key)) !== null && _a !== void 0 ? _a : {};
        custom[name] = customMetadata;
        store.set(key, custom);
    }
}

export { setCustomMetadata };
//# sourceMappingURL=ui-decorator-utils.js.map
